import React from 'react'
import '../sass/components/_grid-layout.scss'

const GridLayout = ({ children }) => {
  return <div className="grid-layout">{children}</div>
}

export default GridLayout
